import { useUserContext } from "@/app/_hooks/useUserContext";
import { EmailRequestBody } from "../@types/email";
import { authenticatedFetch } from "../_utils/authenticatedFetch";

interface StageUpdateArgs {
  jobSpecimen: string;
  stage: string;
  clientUid: string;
  clientEmail: string;
  jobUid?: string;
  jobId?: number;
}

const useSendStageUpdateEmail = () => {
  const {
    email,
    uid,
    settings: { portalBkgColor, portalTextColor, logoSrc, name },
  } = useUserContext();

  const sendStageUpdateEmail = async ({
    jobSpecimen,
    stage,
    clientUid,
    clientEmail,
    jobUid,
    jobId,
  }: StageUpdateArgs): Promise<string> => {
    try {
      const body: EmailRequestBody = {
        clientUid,
        clientEmail,
        userEmail: email,
        stage: stage as Stage,
        portalBkgColor,
        portalTextColor,
        jobSpecimen,
        logoUrl: logoSrc ? logoSrc : "",
        storeName: name,
        jobUid,
        jobId,
      };
      const response = await authenticatedFetch("/api/email/stageUpdate", {
        method: "POST",
        body: JSON.stringify(body),
      });

      if (response.ok) {
        return "Email sent";
      } else {
        // TODO: logging
        return "Email failed";
      }
    } catch (error) {
      // TODO: loggin
      // throw error;
      return "Email failed";
    }
  };

  return sendStageUpdateEmail as (args: StageUpdateArgs) => Promise<string>;
};

export default useSendStageUpdateEmail;
